import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { getItemsFromApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { getAvailableChatParticipants, UserMultiSelect } from '../../../../User'
import { CHAT_FORM_FIELD_NAME_PARTICIPANTS } from '../../ChatForm.constants'

function ParticipantField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      multi
      Component={FormFieldSelectNG}
      Select={UserMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Chat.ParticipantsPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Chat.ParticipantsLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getAvailableChatParticipants}
      getDataItems={getItemsFromApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={CHAT_FORM_FIELD_NAME_PARTICIPANTS}
    />
  )
}

export default ParticipantField
